import React from 'react';
import { TrendingDownIcon, TrendingUpIcon } from 'lucide-react';
import { Card } from '../ui/Card';
import { executiveMetrics } from '../../data/reporting';
import { formatSeconds } from '../../utils/format';
interface Metric {
  label: string;
  value: string;
  trend?: {
    value: string;
    good: boolean;
    direction: 'up' | 'down';
  };
  caption?: string;
}
export function MetricCards() {
  const m = executiveMetrics;
  const metrics: Metric[] = [{
    label: 'Past Due Activities',
    value: `${m.overallPastDuePct}%`,
    trend: {
      value: `${Math.abs(m.trends.overallPastDuePct)} pts`,
      good: true,
      direction: 'down'
    },
    caption: 'vs. last week'
  }, {
    label: 'Average Speed to Lead',
    value: formatSeconds(m.speedToLeadSeconds),
    trend: {
      value: `${Math.abs(m.trends.speedToLeadSeconds)}s`,
      good: true,
      direction: 'down'
    },
    caption: 'vs. last week'
  }, {
    label: 'Contact Rate',
    value: `${m.contactRate}%`,
    trend: {
      value: `${m.trends.contactRate} pts`,
      good: true,
      direction: 'up'
    },
    caption: 'vs. last week'
  }, {
    label: 'Leads Worked Today',
    value: m.leadsWorkedToday.toLocaleString(),
    trend: {
      value: `${m.trends.leadsWorkedToday}%`,
      good: true,
      direction: 'up'
    },
    caption: `${m.leadsRemaining.toLocaleString()} remaining`
  }];
  return <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4" data-id="element-274" data-mp="1q65u2x238ier">
      {metrics.map(metric => <Card key={metric.label} className="px-5 py-5" data-id="element-275" data-mp="1v5irgbql57vl">
          <p className="text-xs font-medium text-ink-500" data-id="element-276" data-mp="20555gne8ms5g">{metric.label}</p>
          <div className="mt-2 flex items-end gap-2.5" data-id="element-277" data-mp="24wmympa0rofv">
            <p className="tabular text-3xl font-semibold tracking-tight text-ink-900" data-id="element-278" data-mp="24z9cf6ni706j">
              {metric.value}
            </p>
            {metric.trend ? <span className={`mb-1 flex items-center gap-1 text-xs font-medium ${metric.trend.good ? 'text-emerald-700' : 'text-rose-700'}`} data-id="element-279" data-mp="2dz5vmsr4j6u7">
                {metric.trend.direction === 'down' ? <TrendingDownIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-280" data-mp="etmmi5l2lkok" /> : <TrendingUpIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-281" data-mp="sl190me6s40d" />}
                {metric.trend.value}
              </span> : null}
          </div>
          {metric.caption ? <p className="mt-1.5 text-xs text-ink-400" data-id="element-282" data-mp="12hmef8u4bh4q">{metric.caption}</p> : null}
        </Card>)}
    </div>;
}